/** Maps Enterprise diagram cards to connector API ids. */

export const ENTERPRISE_SOURCE_CARDS = [
  { id: "cmdb", name: "CMDB", detail: "System of record for inventory" },
  { id: "github", name: "GitHub / GitLab", detail: "Repository & code truth" },
  { id: "jira", name: "Jira / Azure DevOps", detail: "Delivery execution" },
  { id: "servicenow", name: "ServiceNow", detail: "ITSM & change" },
  { id: "observability", name: "Observability", detail: "Telemetry & health signals" },
  { id: "finops", name: "FinOps", detail: "Actual cloud spend" },
  { id: "confluence", name: "Confluence / Wiki", detail: "Architecture and knowledge" },
];

export const ENTERPRISE_OUTCOME_CARDS = [
  { id: "cloud-platforms", name: "Cloud platforms", detail: "Where target workloads land" },
  { id: "cicd", name: "CI/CD toolchain", detail: "Deployment execution" },
  { id: "sre", name: "SRE / IRM", detail: "Production health & response" },
  { id: "grc", name: "GRC / SIEM", detail: "Compliance & security posture" },
  { id: "erp-finance", name: "ERP / Finance", detail: "Cost baseline & realized savings" },
];

export function connectorIntakeHref(appId, connectorId, { openIntake = true } = {}) {
  const params = new URLSearchParams();
  if (appId) params.set("app", appId);
  params.set("focus", "sources");
  if (connectorId) params.set("connector", connectorId);
  if (openIntake) params.set("open", "intake");
  return `/evidence?${params.toString()}`;
}

export function connectorDeliveryHref(appId, connectorId) {
  const params = new URLSearchParams();
  if (appId) params.set("app", appId);
  params.set("focus", "value");
  if (connectorId) params.set("connector", connectorId);
  return `/delivery?${params.toString()}`;
}

export function intakeTabForChannel(channel) {
  if (channel === "json") return "JSON";
  if (channel === "document") return "Document";
  return "CSV / Excel";
}

export function replayContent(replay) {
  if (!replay) return { content: "", filename: "" };
  if (replay.channel === "document") {
    return { content: replay.sample_document || "", filename: replay.filename || "export.txt" };
  }
  return { content: replay.sample_csv || "", filename: replay.filename || "export.csv" };
}
